export default "<div id=\"iberoplast-chat-target\"></div>\r\n\r\n"